import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './branch-locator-item.component.scss';
var BranchLocatorItem = /** @class */ (function (_super) {
    tslib_1.__extends(BranchLocatorItem, _super);
    function BranchLocatorItem(element) {
        return _super.call(this, element) || this;
    }
    BranchLocatorItem.prototype.init = function () {
    };
    BranchLocatorItem.prototype.bindEvents = function () {
    };
    return BranchLocatorItem;
}(Base));
export { BranchLocatorItem };



//////////////////
// WEBPACK FOOTER
// ./components/branch-locator-item/branch-locator-item.component.ts
// module id = 152
// module chunks = 0